"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = tslib_1.__importDefault(require("react"));
const prop_types_1 = tslib_1.__importDefault(require("prop-types"));
const Dialog_1 = tslib_1.__importDefault(require("./Dialog"));
/*
 * Confirmation dialog component to confirm or cancel an action
 */
const ConfirmationDialog = props => {
    const { content, onClickCancel, cancelButtonText, onClickConfirm, confirmButtonText, disableConfirm } = props, remainingProps = tslib_1.__rest(props, ["content", "onClickCancel", "cancelButtonText", "onClickConfirm", "confirmButtonText", "disableConfirm"]);
    const footer = ((0, jsx_runtime_1.jsxs)("div", Object.assign({ className: 'display-flex justify-content-end btn-toolbar' }, { children: [(0, jsx_runtime_1.jsx)("button", Object.assign({ type: 'button', className: 'CancelButton btn btn-default', onClick: onClickCancel }, { children: cancelButtonText })), (0, jsx_runtime_1.jsx)("button", Object.assign({ type: 'button', className: 'ConfirmationButton btn btn-primary', onClick: onClickConfirm, disabled: disableConfirm }, { children: confirmButtonText }))] })));
    return ((0, jsx_runtime_1.jsx)(Dialog_1.default, Object.assign({}, remainingProps, { body: content, footer: footer, onHide: onClickCancel, showCloseButton: false, className: 'confirmation-dialog', disableEsc: true })));
};
ConfirmationDialog.defaultProps = {
    show: false,
    onClickCancel: () => { },
    onClickConfirm: () => { },
};
ConfirmationDialog.propTypes = {
    show: prop_types_1.default.bool.isRequired,
    title: prop_types_1.default.node.isRequired,
    subtitle: prop_types_1.default.node,
    content: prop_types_1.default.node.isRequired,
    onClickCancel: prop_types_1.default.func.isRequired,
    onClickConfirm: prop_types_1.default.func.isRequired,
    cancelButtonText: prop_types_1.default.node.isRequired,
    confirmButtonText: prop_types_1.default.node.isRequired,
    disableConfirm: prop_types_1.default.bool,
    bsSize: prop_types_1.default.string,
};
exports.default = ConfirmationDialog;
